import { NgModule } from '@angular/core';
import { HotkeysModule } from '@ngneat/hotkeys';

import { CommonHotkeyService } from './services/hotkey.service';
import { CommonPopupModule } from '@CaseOne/Common/popup/popup.module';

@NgModule({
	imports: [
		HotkeysModule,
		CommonPopupModule,
	],
	providers: [
		CommonHotkeyService,
	],
})
export class CommonHotkeyModule {}
